export default __webpack_public_path__ + "static/media/Hungama_logo.22530f1b.png";